export default {"src":"/_next/static/media/buy_in_web_40_41x40.944af2ab.svg","height":40,"width":41,"blurWidth":0,"blurHeight":0};